export const summaryColumnValue = [
  'start_date',
  'end_date',
  'duration',
  'progress',
  'cost', // budgeted cost
  'used_cost', // actual cost
  'hhWorkTime'
];
